function tryOnce(locks: LockManager, name: string): Promise<(() => void) | null> {
  return new Promise((resolve) => {
    void locks.request(name, { ifAvailable: true }, (lock) => {
      if (!lock) {
        resolve(null);
        return undefined;
      }
      // Hold the lock until the returned release function is called.
      return new Promise<void>((release) => resolve(() => release()));
    });
  });
}

/** Resolves to a release function, or null if another tab keeps the lock. */
export async function acquireTabLock(
  name: string,
  opts: { attempts?: number; delayMs?: number } = {},
): Promise<(() => void) | null> {
  const locks = typeof navigator !== 'undefined' ? navigator.locks : undefined;
  if (!locks) return () => {};
  const attempts = opts.attempts ?? 5;
  const delayMs = opts.delayMs ?? 200;
  for (let i = 0; i < attempts; i++) {
    const release = await tryOnce(locks, name);
    if (release) return release;
    if (i < attempts - 1) await new Promise((r) => setTimeout(r, delayMs));
  }
  return null;
}
